import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
  DeleteIconBox,
  FlexWrapper,
  HighlightText,
  PaginationBox,
  ViewIconBox
} from '../../theme/common_style';
import {
  AndroidIcon,
  AppleIcon,
  DeleteIcon,
  FilterIconNew,
  HmsCardIcon1,
  HmsCardIcon2,
  HmsCardIcon3,
  HmsCardIcon4,
  HmsCardIcon5,
  NoData,
  NoMilestone,
  TrashIconNew,
  ViewIconNew,
  WindowIcon
} from '../../theme/SvgIcons';
import { Badge, Button, Drawer, Pagination, Segmented, Table } from 'antd';
import SearchField from '../../components/searchField/SearchField';
import EmptyData from '../../components/common/EmptyData';
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from '../../components/Modal/ConfirmationModal';
import AddModal from './AddModal';
import { updateActivityDrawer } from '../../redux/sidebar/SidebarSlice';
import { useDispatch, useSelector } from 'react-redux';
import HmsFilter from './HmsFilter';
import ActivityEmployee from './ActivityDrawer';
import {
  deleteDevice,
  getAssignDeviceListing,
  getDeviceCounts,
  getDeviceListing,
  returnDevice
} from '../../services/api_collection';
import { toast } from 'react-toastify';
import useDepartmentOptions from '../../hooks/useDepartmentOptions';
import {
  checkPermission,
  debounce,
  generateEmployeeImgUrl,
  getFullName,
  useWindowWide
} from '../../utils/common_functions';
import useDesignationOptions from '../../hooks/useDesignationOptions';
import { AvatarGroup } from '../../components/common/AvatarGroup';
import { StickyBox } from '../../utils/style';
import { hmsTabEnum, HMSTabOptions } from '../../utils/constant';
import { updateHmsTab } from '../../redux/hms/HmsSlice';
import { getStatusTag } from './common';
import dayjs from 'dayjs';
import HmsCard from './details/components/HmsCard';
import HmsOsType from './details/components/HmsOsType';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';

const HMS = () => {
  const activeTab = useSelector((state) => state?.HmsSlice?.HmsTab);
  const [search, setSearch] = useState('');
  const [filterDrawer, setFilterDrawer] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteId, setDeletedId] = useState(null);
  const [returnDeviceData, setReturnDeviceData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deviceListing, setDeviceListing] = useState([]);
  const largeScreen = useWindowWide(1085);
  const mediumScreen = useWindowWide(600);
  const [filterData, setFilterData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(20);
  const [total, setTotal] = useState(20);
  const [countsDetails, setCountsDetail] = useState(null);
  const activityDrawer = useSelector((state) => state?.sidebar?.isActivityDrawer);
  const { permissions } = useSelector((state) => state?.userInfo?.data);
  const { options: departmentOptions } = useDepartmentOptions();
  const canCreate = checkPermission('HMS', 'create', permissions);
  const canDelete = checkPermission('HMS', 'del', permissions);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [designationOptions, setDesignationOptions] = useState({});
  const [cardLoading, setCardLoading] = useState(false);
  const theme = useTheme();

  const [sort, setSort] = useState({});

  const handleSorting = (val) => {
    if (val?.field) {
      let order = val?.order == 'ascend' ? 'ASC' : 'DESC';
      setSort({ sortBy: val?.field, orderBy: order, ...val });
    } else {
      setSort({});
    }
    setPage(page);
  };

  const columns =
    activeTab === hmsTabEnum?.INVENTORY
      ? [
          {
            title: 'S. NO',
            dataIndex: 'key',
            key: 'key',
            render: (_, __, index) => <span>{(page - 1) * limit + index + 1}.</span>
          },
          {
            title: 'Device ID',
            dataIndex: 'device_id',
            key: 'device_id',
            sorter: true,
            render: (id, data) => (
              <HighlightText
                onClick={() => {
                  navigate(`/hms/details`, {
                    state: { hms: data, activeTab: hmsTabEnum?.INVENTORY, id: data?.id }
                  });
                }}>
                {id}
              </HighlightText>
            )
          },
          {
            title: 'Device Type',
            dataIndex: 'device_type',
            key: 'device_type',
            sorter: true
          },
          {
            title: 'OS Type',
            dataIndex: 'os_type',
            key: 'os_type',
            sorter: true,
            render: (val) => val || 'N/A'
          },
          {
            title: 'Brand',
            dataIndex: 'brand',
            key: 'brand',
            sorter: true
          },
          // {
          //   title: 'Model',
          //   dataIndex: 'model',
          //   key: 'model'
          // },
          {
            title: 'Assigned To',
            dataIndex: 'assigned_to',
            key: 'assigned_to',
            sorter: true,
            render: (_, record) => {
              const emp = record?.device?.[0]?.employee;
              const name = emp
                ? getFullName(emp?.first_name, emp?.middle_name, emp?.last_name)
                : 'N/A';
              return <span>{name}</span>;
            }
          },
          {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            sorter: true,
            render: (status) => getStatusTag(status)
          },
          {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            className: 'action-column',
            render: (_, data) => {
              return (
                <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor={'default'}>
                  <ViewIconBox
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      navigate(`/hms/details`, {
                        state: { hms: data, activeTab: hmsTabEnum?.INVENTORY, id: data?.id }
                      });
                    }}>
                    <ViewIconNew />
                  </ViewIconBox>
                  {canDelete && (
                    <DeleteIconBox
                      canDelete={canDelete}
                      onClick={() => {
                        setDeletedId(data?.id);
                        setDeleteModal(true);
                      }}>
                      <DeleteIcon />
                    </DeleteIconBox>
                  )}
                </FlexWrapper>
              );
            }
          }
        ]
      : activeTab === hmsTabEnum?.ASSIGNEE && [
          { title: 'S. NO', dataIndex: 'id', key: 'id', render: (_, __, i) => i + 1 },
          {
            title: 'Assigned To',
            dataIndex: 'assignee',
            key: 'assignee',

            render: (_, data) => {
              let empName = getFullName(data?.employee?.first_name);
              const imgData = [
                {
                  name: empName,
                  src: generateEmployeeImgUrl(data?.employee?.id),
                  id: data?.employee?.id
                }
              ];
              return (
                <FlexWrapper
                  cursor="pointer"
                  onClick={() => {
                    navigate(`/hms/details`, {
                      state: { hms: data, id: data?.device?.id }
                    });
                  }}
                  wrap="no-wrap"
                  justify={'start'}
                  gap={'6px'}>
                  <AvatarGroup avatars={imgData} />
                  <HighlightText>{empName}</HighlightText>
                </FlexWrapper>
              );
            }
          },
          {
            title: 'Department',
            dataIndex: 'department',
            key: 'employee',
            render: (_, data) => {
              const matchDepartment = departmentOptions?.find(
                (val) => val?.value == data?.employee?.department
              );
              return <p>{matchDepartment ? matchDepartment?.label : 'N/A'}</p>;
            }
          },
          {
            title: 'Designation',
            dataIndex: 'designation',
            key: 'designation',
            render: (_, data) => {
              const department = designationOptions[data?.id];
              return <p>{department ? department : 'N/A'}</p>;
            }
          },
          {
            title: 'Device ID',
            dataIndex: 'device_id',
            key: 'device_id',
            render: (id, data) => {
              return <p>{data?.device?.device_id}</p>;
            }
          },
          {
            title: 'Date Assigned',
            dataIndex: 'assign_date',
            key: 'assign_date',
            render: (assign_date) => {
              if (!assign_date || isNaN(Number(assign_date))) return <p>--</p>;
              const date = dayjs(Number(assign_date));
              return <p>{date.format('YYYY-MM-DD')}</p>;
            }
          },
          {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            className: 'action-column',
            render: (_, data) => {
              return (
                <FlexWrapper justify={'start'} gap={'6px'} wrap={'unset'} cursor={'default'}>
                  <ViewIconBox
                    onClick={() => {
                      navigate(`/hms/details`, {
                        state: { hms: data, id: data?.device?.id }
                      });
                    }}>
                    <ViewIconNew />
                  </ViewIconBox>
                  {canDelete && (
                    <DeleteIconBox
                      canDelete={canDelete}
                      onClick={() => {
                        setReturnDeviceData(data);
                        setDeleteModal(true);
                      }}>
                      <DeleteIcon />
                    </DeleteIconBox>
                  )}
                </FlexWrapper>
              );
            }
          }
        ];

  const getCountByStatus = (status) => {
    return (
      countsDetails?.data?.statusWise?.find(
        (item) => item.status.toLowerCase() === status.toLowerCase()
      )?.count || 0
    );
  };

  const statsData = [
    {
      icon: <HmsCardIcon1 />,
      bg: '#DDF3FF',
      label: 'Total Hardware',
      value: countsDetails?.count || 0,
      filterKey: 'total'
    },
    {
      icon: <HmsCardIcon2 />,
      bg: '#E4FFDD',
      label: 'Available',
      value: getCountByStatus('available'),
      filterKey: 'available'
    },
    {
      icon: <HmsCardIcon3 />,
      bg: '#E1E7FF',
      label: 'Assigned',
      value: getCountByStatus('assigned'),
      filterKey: 'assigned'
    },
    {
      icon: <HmsCardIcon4 />,
      bg: '#FFF3DB',
      label: 'Maintenance',
      value: getCountByStatus('maintenance'),
      filterKey: 'maintenance'
    },
    {
      icon: <HmsCardIcon5 />,
      bg: '#FFCCC8',
      label: 'Retired',
      value: getCountByStatus('retired'),
      filterKey: 'retired'
    }
  ];

  const Icons = {
    desktop_window: <WindowIcon />,
    desktop_mac: <AppleIcon />,
    laptop_window: <WindowIcon />,
    laptop_mac: <AppleIcon />,
    mobile_iphone: <AppleIcon />,
    mobile_android: <AndroidIcon />,
    tablet_ipad: <AppleIcon />,
    tablet_tab: <AndroidIcon />
  };
  const filterKey = {
    desktop_window: 'Desktop_Windows',
    desktop_mac: 'Desktop_Mac',
    laptop_window: 'Laptop_Windows',
    laptop_mac: 'Laptop_Mac',
    mobile_android: 'Mobile_Android',
    mobile_iphone: 'Mobile_iOS',
    tablet_tab: 'Tablet_Android',
    tablet_ipad: 'Tablet_iOS'
  };
  const statsOsData = [
    {
      label: 'Desktop',
      keys: {
        desktop_window: 'Windows',
        desktop_mac: 'Mac'
      }
    },
    {
      label: 'Laptop',
      keys: {
        laptop_window: 'Windows',
        laptop_mac: 'Mac'
      }
    },
    {
      label: 'Mobile',
      keys: {
        mobile_android: 'Android',
        mobile_iphone: 'iPhone'
      }
    },
    {
      label: 'Tablet',
      keys: {
        tablet_tab: 'Android Tab',
        tablet_ipad: 'iPad'
      }
    }
  ];

  const structuredData = useMemo(() => {
    return statsOsData.map((item) => {
      const items = Object.entries(item.keys).map(([key, name]) => ({
        label: name,
        value: parseInt(countsDetails?.data?.typeOsWise[key]) || 0,
        icon: Icons[key],
        filterKey: filterKey[key]
      }));
      return {
        label: item.label,
        items
      };
    });
  }, [countsDetails?.data?.typeOsWise]);

  const fetchDesignation = async (data) => {
    const res = await useDesignationOptions(data?.employee?.department);
    let designation = res?.find((item) => item?.id == data?.employee?.designation);
    setDesignationOptions((prev) => ({
      ...prev,
      [data?.id]: designation?.designation
    }));
  };

  const handlOnChange = (page, pageSize) => {
    setLimit(pageSize);
    setPage(page);
  };

  const handleGetCounts = async () => {
    setCardLoading(true);
    let res = await getDeviceCounts();
    if (res?.statusCode === 200) {
      setCountsDetail(res);
      setCardLoading(false);
    } else {
      toast.error(
        res?.response?.data?.message || res?.error || res?.message || 'Something went wrong'
      );
      setCardLoading(false);
    }
  };

  const handleGetDeviceListing = async (search) => {
    setLoading(true);
    let params = new URLSearchParams();
    params.append('limit', limit);
    params.append('pageNumber', page);
    search && params.append('searchKey', search);

    sort?.sortBy && params.append('sortBy', sort?.sortBy);
    sort?.orderBy && params.append('sortOrder', sort?.orderBy);

    if (Array.isArray(filterData?.device_type)) {
      filterData?.device_type && params.append('device_type', filterData?.device_type);
    }

    if (Array.isArray(filterData?.status)) {
      filterData?.status && params.append('status', filterData?.status);
    }
    let res = await getDeviceListing(params);
    if (res?.statusCode === 200) {
      setLoading(false);
      setTotal(res?.count);
      setDeviceListing(res?.data);
    } else {
      setLoading(false);
      setDeviceListing([]);
      toast.error(
        res?.response?.data?.message || res?.error || res?.message || 'Something went wrong'
      );
    }
  };

  const handlegetAssignDeviceListing = async (search) => {
    setLoading(true);
    let params = new URLSearchParams();
    params.append('limit', limit);
    params.append('pageNumber', page);
    search && params.append('searchKey', search);
    filterData?.device_type && params.append('device_type', filterData?.device_type);
    filterData?.status && params.append('department', filterData?.status);
    let res = await getAssignDeviceListing(params);
    if (res?.statusCode === 200) {
      setLoading(false);
      setTotal(res?.count);
      setDeviceListing(res?.data);
    } else {
      setLoading(false);
      setDeviceListing([]);
      toast.error(
        res?.response?.data?.message || res?.error || res?.message || 'Something went wrong'
      );
    }
  };

  const handleReturnDevice = async () => {
    let res = await returnDevice(returnDeviceData?.device?.id, returnDeviceData?.employee?.id);
    if (res?.statusCode === 200) {
      toast.success(res?.message);
      setDeleteModal(false);
      handlegetAssignDeviceListing();
      handleGetCounts();
    } else {
      toast.error(
        res?.response?.data?.message || res?.error || res?.message || 'Something went wrong'
      );
    }
  };

  const handleDelete = async () => {
    setDeleteLoading(true);
    let res = await deleteDevice(deleteId);
    if (res.statusCode === 200) {
      setDeleteLoading(false);
      toast.success(res?.message);
      handleGetDeviceListing();
      handleGetCounts();
      setDeleteModal(false);
    } else {
      setDeleteLoading(false);
      toast.error(
        res?.response?.data?.message || res?.error || res?.message || 'Somehing went wrong'
      );
    }
  };

  const optimizedFnAssign = useCallback(debounce(handlegetAssignDeviceListing), [
    page,
    limit,
    filterData,
    activeTab
  ]);
  const optimizedFnInventory = useCallback(debounce(handleGetDeviceListing), [
    page,
    limit,
    filterData,
    activeTab,
    sort
  ]);

  useEffect(() => {
    if (activeTab == hmsTabEnum?.INVENTORY) {
      if (search !== null) {
        optimizedFnInventory(search);
      } else {
        handleGetDeviceListing();
      }
    } else if (activeTab == hmsTabEnum?.ASSIGNEE) {
      if (search !== null) {
        optimizedFnAssign(search);
      } else {
        handlegetAssignDeviceListing();
      }
    }
  }, [page, limit, search, filterData, activeTab, sort]);

  useEffect(() => {
    if (activeTab === hmsTabEnum?.ASSIGNEE) {
      deviceListing?.map((item) => fetchDesignation(item));
    }
  }, [deviceListing]);

  useEffect(() => {
    handleGetCounts();
  }, []);

  const manageIconSelectFilter = (filterKey, keyType) => {
    if (!filterKey) return;

    const isTotalFilter = filterKey === 'total';
    const currentFilterValues = filterData?.[keyType] || [];

    if (isTotalFilter && keyType === 'status') {
      setFilterData((prev) => ({ ...prev, [keyType]: [] }));
    } else {
      const updatedFilterValues = currentFilterValues.includes(filterKey)
        ? currentFilterValues.filter((item) => item !== filterKey)
        : [...currentFilterValues, filterKey];

      setFilterData((prev) => ({ ...prev, [keyType]: updatedFilterValues }));
    }

    setPage(1);
  };

  return (
    <div>
      {deleteModal && (
        <ConfirmationModal
          open={deleteModal}
          onCancel={() => setDeleteModal(false)}
          title={activeTab == hmsTabEnum?.INVENTORY ? 'Delete Hardware' : 'Return Device'}
          onSubmit={activeTab == hmsTabEnum?.INVENTORY ? handleDelete : handleReturnDevice}
          buttonName={activeTab == hmsTabEnum?.INVENTORY ? 'Delete' : 'Return'}
          description={
            activeTab == hmsTabEnum?.INVENTORY
              ? 'Are you sure you want to delete this Hardware?'
              : 'Are you sure you want to Return this Device?'
          }
          iconBG={'#FB4A49'}
          icon={<TrashIconNew />}
          loading={deleteLoading}
          deleteId={deleteId}
        />
      )}
      {activityDrawer && (
        <Drawer
          width={490}
          title="Activity"
          placement="right"
          closable={true}
          prefixCls="activityCustomDrawer"
          onClose={() => dispatch(updateActivityDrawer(false))}
          open={activityDrawer}
          key="right">
          <ActivityEmployee />
        </Drawer>
      )}
      {addModal && (
        <AddModal
          open={addModal}
          onClose={() => setAddModal(false)}
          handleCount={handleGetCounts}
          handleGetDeviceListing={
            activeTab == hmsTabEnum?.INVENTORY
              ? handleGetDeviceListing
              : handlegetAssignDeviceListing
          }
        />
      )}
      {filterDrawer && (
        <HmsFilter
          open={filterDrawer}
          onClose={() => setFilterDrawer(false)}
          filterData={filterData}
          setFilterData={setFilterData}
          setPage={setPage}
        />
      )}
      <GridBoxTopcard cols="5">
        {(statsData || [])?.map((item, index) => (
          <div key={item?.bg + index}>
            <HmsCard
              image={item.icon}
              bg={item.bg}
              loading={cardLoading}
              filterKey={item.filterKey}
              onClick={(val) =>
                activeTab == hmsTabEnum?.INVENTORY && manageIconSelectFilter(val, 'status')
              }
              title={item.label}
              value={item.value}
              active={filterData?.status || []}
            />
          </div>
        ))}
      </GridBoxTopcard>
      <GridBoxTopcard cols="4" style={{ marginTop: '16px' }}>
        {(structuredData || [])?.map((item, index) => (
          <div key={item?.bg + index}>
            <HmsOsType
              cols={item?.items?.length}
              title={item?.label}
              loading={cardLoading}
              content={item?.items}
              onClick={(val) =>
                activeTab == hmsTabEnum?.INVENTORY && manageIconSelectFilter(val, 'device_type')
              }
              active={filterData?.device_type || []}
            />
          </div>
        ))}
      </GridBoxTopcard>

      <StickyBox padding="8px 0">
        <FlexWrapper
          width={'100%'}
          justify={largeScreen ? 'space-between' : 'start'}
          gap="16px"
          cursor="default"
          margin="12px 0"
          style={{ marginBottom: '16px' }}>
          <FlexWrapper justify="start" align="start" width={mediumScreen ? 'fit-content' : '100%'}>
            <Segmented
              value={activeTab}
              prefixCls="antCustomSegmented"
              options={HMSTabOptions}
              onChange={(value) => {
                setAddModal(false);
                setDeviceListing([]);
                setLoading(true);
                dispatch(updateHmsTab(value));
                setFilterData({});
              }}
            />
          </FlexWrapper>

          <FlexWrapperParent justify={'end'} gap="6px" cursor="default">
            <SearchField
              placeholder="Search by Device Type..."
              width={'250px'}
              value={search}
              onChange={(value) => {
                setSearch(value);
                setPage(1);
              }}
            />
            <BoxButton>
              <Badge
                count={Object?.values(filterData || {})?.reduce(
                  (acc, item) =>
                    acc + (item ? (Array.isArray(item) ? (item?.length > 0 ? 1 : 0) : 1) : 0),
                  0
                )}
                color={theme?.primaryColor}
                offset={[-9, 4]}
                prefixCls="filterBadge">
                <Button prefixCls="custom-filter-btn" onClick={() => setFilterDrawer(true)}>
                  <FilterIconNew /> Filter
                </Button>
              </Badge>
              {canCreate && (
                <Button type="text" onClick={() => setAddModal(true)} prefixCls="antCustomBtn">
                  {activeTab === hmsTabEnum?.INVENTORY
                    ? '+ Add Hardware'
                    : activeTab === hmsTabEnum?.ASSIGNEE && 'Assign Hardware'}
                </Button>
              )}
            </BoxButton>
          </FlexWrapperParent>
        </FlexWrapper>
      </StickyBox>

      {loading || deviceListing?.length > 0 ? (
        <>
          <Table
            prefixCls="antCustomTable"
            columns={columns}
            dataSource={deviceListing}
            pagination={false}
            loading={loading}
            onChange={(_, filters, sorter) => {
              handleSorting(sorter);
            }}
            defaultSortOrder={sort.order}
          />
          {total > limit && (
            <PaginationBox>
              <Pagination
                current={page}
                prefixCls="custom-pagination"
                pageSize={limit}
                total={total}
                onChange={handlOnChange}
                showSizeChanger={false}
              />
            </PaginationBox>
          )}
        </>
      ) : (
        <>
          <EmptyData
            height={'50vh'}
            icon={
              activeTab === hmsTabEnum?.INVENTORY ? (
                <NoData />
              ) : (
                activeTab === hmsTabEnum?.ASSIGNEE && <NoMilestone />
              )
            }
            title={
              activeTab === hmsTabEnum?.INVENTORY
                ? 'No Hardware'
                : activeTab === hmsTabEnum?.ASSIGNEE && 'No Assignee'
            }
            subTitle={
              <FlexWrapper direction="column">
                <p style={{ margin: 0 }}>
                  {activeTab === hmsTabEnum?.INVENTORY
                    ? 'No hardware add yet kindly add first hardware'
                    : activeTab === hmsTabEnum?.ASSIGNEE &&
                      'No device assignee yet kindly assign first device'}
                </p>
                {canCreate && (
                  <Button
                    onClick={() => setAddModal(true)}
                    prefixCls="antCustomBtn"
                    style={{ margin: '16px 0' }}>
                    {activeTab === hmsTabEnum?.INVENTORY
                      ? '+ Add Hardware'
                      : activeTab === hmsTabEnum?.ASSIGNEE && 'Assign Hardware'}
                  </Button>
                )}
              </FlexWrapper>
            }
          />
        </>
      )}
    </div>
  );
};

export default HMS;

const GridBoxTopcard = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ cols }) => `repeat(${cols}, 1fr)`};
  gap: ${({ gap }) => gap || '16px'};

  @media (max-width: 800px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 5px;
  }
`;
export const FlexWrapperParent = styled.div`
  width: ${(props) => props.width};
  display: flex;
  flex-wrap: ${(props) => props.wrap || 'nowrap'};
  flex-direction: ${(props) => props.direction || 'row'};
  justify-content: ${(props) => props.justify || 'center'};
  align-items: ${(props) => props.align || 'center'};
  gap: ${(props) => props.gap || '10px'};
  cursor: ${(props) => props.cursor || 'auto'};
  margin: ${(props) => props.margin || '0px'};

  @media (max-width: 768px) {
    width: 100%;
    flex-wrap: wrap;
    justify-content: start;
  }

  @media (max-width: 568px) {
    width: 100%;
    align-items: start;
    justify-content: start;
    flex-direction: column;
  }
`;
const BoxButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  @media (max-width: 668px) {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }
`;
